module.exports = __webpack_public_path__ + "assets/img/mecha-btn-9b266a32.png";